module.exports = __webpack_public_path__ + "static/media/speaker-outline.c2701cb6.svg";